<div class="page-padding">

  <div class="panel__header">
    <span class="panel__header__title">Component Setup</span>
  </div>

  <div style="margin-left: 39%;" *ngIf="loading">
    <mat-spinner> </mat-spinner>
  </div>

  <div class="step-container">


    <div>


      <!--schemantic images adding-->
      <div class="margin-bottom-24" style="white-space: nowrap;">
        <input hidden type='file' accept="image/*" (change)="onSelectSchematicPhoto($event)" #uploadSchematicImage>

        <ng-container>
          <div class="add-new-schematic" (click)="uploadSchematicImage.click()"
               style="float: left;"
               matTooltip="Click to upload a schematic image (JPG format recommended)">
            <i class="material-icons add-new-schematic__icon">add_box</i>
            <div class="add-new-schematic__text">Add new</div>
          </div>

          <ng-container *ngFor="let sch of schematicList">
            <div class="implement-image-container2 ">
              <div class="div-hide-schematic">
                <mat-icon *ngIf="sch.OBSCount == sch.InactiveOBSCount" class="hide-schematic" [ngClass]="sch.IsHidden ? 'gray-icon' : 'red-icon'"
                          [title]="sch.IsHidden ? 'Click to unhide schematic' : 'Click to hide schematic'" (click)="openHideConfirmationBox(sch.Id, sch.ImageName, sch.IsHidden)">visibility_off</mat-icon>

              </div>
              <img [src]="getImage(sch.Data)" class="selection__image" (click)="!sch.IsHidden && openSchematicWindow(sch, 2)" [title]="!sch.IsHidden
                              ? 'View expanded schematic with component type mapping'
                              : 'Schematic is hidden and not available for viewing'"
                   style="width: 100%; height: 100%;" />
              <div class="identify-comp">
                <input style="font-size: small;display: flex; justify-content: space-around;" [(ngModel)]="sch.ImageName" (focusout)="UpdateSchmaticImageName(sch)">

                <mat-icon *ngIf="sch.OBSCount == 0 && sch.InactiveOBSCount == 0" title="Click to permanently delete the schematic"
                          style="margin-left: 7px; cursor: pointer; height: 20px;"
                          (click)="deleteimage(sch.Id,sch.IsNewImage,sch.OBSCount)">
                  delete
                </mat-icon>
              </div>
              <div class="identify-comp">
                <span class="link" (click)="openPopup(sch)">
                  Identify Components
                </span>
                <mat-icon (click)="openPopup(sch)" class="link" title="Identify Components">open_in_new</mat-icon>
              </div>

              <div *ngIf="ShowHideSchOrder==true" style="display:flex ; flex-direction: column ; margin-left: 33%;margin-top: 1%;">
                <span title="Move Right"
                      [class.button-hide]="isLastSchematicInList(sch.Id)"
                      (click)="recalculateSortOrderSchematic(sch.Id, true, sch.IsNewImage)">
                  <i class="material-icons" style="cursor: pointer;">arrow_forward</i>
                </span>
                <span title="Move Left"
                      [class.button-hide]="isFirstSchematicInList(sch.Id)"
                      (click)="recalculateSortOrderSchematic(sch.Id, false, sch.IsNewImage)">
                  <i class="material-icons" style="cursor: pointer;"> arrow_back</i>
                </span>
              </div>

            </div>





          </ng-container>
          <div>
            <mat-checkbox id="cbShowHideSchOrder" color="primary" (checked)="ShowHideSchOrder"
                          (click)="toggleShowHideSchOrder()">Show/Hide Schematic Order</mat-checkbox>
          </div>

          <div id="ulSchematics" class="selection-container">

          </div>
        </ng-container>
      </div>



      <div class="question">
        <div class="question__text">Add Components to Implement</div>


        <mat-form-field style="width: 20%">
          <input matInput (keyup)="onComponentListFilterChange()" type="text"
                 placeholder="Filter list" [(ngModel)]="componentListFilter" ngDefaultControl>
        </mat-form-field>


        <!-- <input class="no-grow" (keyup)="onComponentListFilterChange()" type="text"
        placeholder="Filter list" [(ngModel)]="componentListFilter" /> -->

        <mat-checkbox id="cbHideSelectedMPs" color="primary" (checked)="hideSelectedMPs"
                      (click)="toggleSelectedMPs()">Hide Selected</mat-checkbox>
        <mat-checkbox id="cbHideUnselectedMPs" color="primary" (checked)="hideUnselectedMPs"
                      (click)="toggleUnselectedMPs()">Hide Unselected</mat-checkbox>

        <div class="question__control">
          <div>
            <div style="display: flex; margin-top: 16px; margin-bottom: 8px">
              <mat-checkbox id="cbOPComponent_isActive" color="primary"
                            [(ngModel)]="cbAllComponentsSelect"
                            (click)="toggleAllComponents(!cbAllComponentsSelect)"
                            style="margin-left: 0px!important; margin-right: 16px!important;align-self: center">
              </mat-checkbox>
              <div class="ComponentHeadertype center-align-text"><b>Schematic</b></div>
              <div class="ComponentHeadertype center-align-text"><b>Component Type</b></div>
              <div class="ComponentHeader center-align-text"><b>Component Name</b></div>

              <div class="ComponentHeaderGET"><b style="vertical-align: top; padding-left: 14px;">Coords.</b> </div>
              <div class="ComponentHeaderGET"><b style="vertical-align: top; padding-left: 14px;">Locs.</b> </div>

              <div class="center-align-text ComponentHeaderSmall"><b>Make</b></div>
              <div class="ComponentHeaderSmall center-align-text"><b>Part No.</b></div>
              <div class="ComponentHeaderSmall center-align-text"><b>Customer PartNo.</b></div>

              <div class="ComponentHeadercolor center-align-text"><b>Budget Life</b></div>
              <div class="ComponentHeaderGET" style="min-width: 60px !important; width: 60px !important ">
                <b style="vertical-align: top;">Critical</b> <i style="cursor: default;"
                                                                title="Components marked as critical contribute to the overall evaluation of the implement"
                                                                class="material-icons">help</i>
              </div>
              <div class="ComponentHeaderGET"><b style="vertical-align: top; padding-left: 14px;">GET</b> </div>
              <div class="ComponentHeadercolor" style="display:none; min-width: 100px !important; width: 100px !important "><b style="vertical-align: top;">HTML Color</b> </div>
              <div class="ComponentHeaderMaxCrack"><b style="vertical-align: top;">Max Crack Length</b> </div>
              <div class="ComponentHeadercolor"><b style="vertical-align: top;">UOM</b> </div>
              <div class="ComponentHeadercolor"><b style="display: none; vertical-align: top;">Crack Severity List</b> </div>
            </div>
          </div>
          <div class="input-container">
            <div class="select-list--overflow">
              <mat-selection-list #componentTypeListId style="width: 100%;">
                <ng-container *ngFor="let component of componentListFiltered">
                  <mat-list-item *ngIf="selectionLogicForMPs(component.Selected)" style="margin-left: -16px;">
                    <div style="display: flex; align-items: center; margin-top: 8px; margin-bottom: 8px; ">
                      <mat-checkbox id="chkComponent-{{component.Id}}-{{component.IsNew}}"
                                    [checked]="component.Selected" [value]="component.Id"
                                    style="margin-left: 0px!important; margin-right: 16px!important;"
                                    color="primary"
                                    (change)="onComponentListControlChanged(component.Id, component.Name)">
                      </mat-checkbox>
                      <div class="ComponentHeadertype">
                        <span *ngIf="showSchematicImageName(component.Id)">{{component.SchematicName}}</span>
                        <select *ngIf="!showSchematicImageName(component.Id)" class="newCompMatInput_Select" id="ddlSchematics"
                                style="width: 245px; height: 40px; background-color: #F4F7FA;
                                          color: #1D2F36; min-height: 40px; padding: 10px;"
                                [(ngModel)]="component.SchematicId"
                                required>
                          <option value="0"></option>
                          <option [value]="sch.Id"
                                  *ngFor="let sch of visibleSchematics">
                            <!--<img [src]="getImage(sch.Data)" style="width:30px; height: 30px;" />-->
                            {{sch.ImageName}}
                          </option>
                        </select>
                      </div>
                      <div class="ComponentHeadertype">
                        <select class="newCompInput_Select length-input3" id="ComponentType"
                                placeholder="Select Type" style="min-width: 245px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                          color: #1D2F36; min-height: 40px; padding: 10px;"
                                [(ngModel)]="component.CompTypeId" ngDefaultControl
                                required>
                          <option value="0"></option>
                          <option [value]="type.Id"
                                  *ngFor="let type of getFilteredComponentTypes(component.SchematicId)">
                            {{type.Name}}
                          </option>
                        </select>
                      </div>
                      <div class="ComponentHeader">
                        <input (keydown)="allowSpaces($event)" type="text" class="newcomps newCompInput_Select length-input3" id="ComponentName"
                               placeholder="Name" style="min-width: 300px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                      color: #1D2F36; min-height: 40px; padding: 10px;border: 1px solid black;"
                               [(ngModel)]="component.Name"
                               required>
                      </div>

                      <div class="ComponentHeaderGET">
                        <span>{{component.NoOfCoorinates}}</span>
                      </div>
                      <div class="ComponentHeaderGET">
                        <span>{{component.NoOfLocations}}</span>
                      </div>


                      <div class="ComponentHeaderSmall">
                        <select class="newCompInput_Select" id="ComponentMake"
                                placeholder="Select Make" style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black;"
                                [(ngModel)]="component.MakeId" ngDefaultControl required
                                class="length-input3">
                          <option value="0"></option>
                          <option [value]="make.Id" *ngFor="let make of makeList">
                            {{make.Name}}
                          </option>
                        </select>
                      </div>
                      <div class="ComponentHeaderSmall">
                        <input (keydown)="allowSpaces($event)" class="newCompInput_Select length-input3" id="ComponentPartNo"
                               placeholder="PartNo" type="text" style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black; min-width: 150px !important;"
                               [(ngModel)]="component.PartNo"
                               required>
                      </div>

                      <div class="ComponentHeaderSmall">
                        <input (keydown)="allowSpaces($event)" class="length-input3 newCompInput_Select" id="ComponentCusPartNo"
                               placeholder="Customer PartNo" type="text" style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black; min-width: 150px !important;"
                               [(ngModel)]="component.CusPartNo">
                      </div>





                      <div class="ComponentHeadercolor">
                        <input class="newCompInput_Select length-input3medium" id="ComponentBudgetLife"
                               placeholder="Budget Life" type="text" style="height: 40px; width: 78px !important; min-width: 78px !important; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; "
                               [(ngModel)]="component.CompBudgetLife"
                               ngDefaultControl required>
                      </div>

                      <div class="ComponentHeaderGET">
                        <mat-checkbox id="chkComponentCritical-{{component.Id}}-{{component.IsNew}}"
                                      [checked]="component.IsCritical" [value]="component.Id"
                                      style="margin-left: 16px!important; margin-right: 16px!important;-webkit-text-emphasis-style: filled;"
                                      color="primary"
                                      (change)="onComponentCriticalChange($event,component.Id,component)">
                        </mat-checkbox>
                      </div>

                      <div class="ComponentHeaderGET">
                        <mat-checkbox [checked]="component.isGETCritical" [value]="component.Id"
                                      style="margin-left: 16px!important; margin-right: 16px!important;-webkit-text-emphasis-style: filled;"
                                      color="primary"
                                      (change)="onGETComponentCriticalChange($event,component.Id,component)">
                        </mat-checkbox>
                      </div>
                      <!-- TT-5655  -->

                      <div class="ComponentHeadercolor" style="display: none; ">
                        <select class="newCompInput_SelectMaxCrack" id="HTMLColor"
                                placeholder="Color" style="height: 40px; width: 65px !important; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid; "
                                [(ngModel)]="component.ColorCodeID" ngDefaultControl
                                required>
                          <option value="0"></option>
                          <option [value]="code.ID"
                                  *ngFor="let code of colorCodeList">
                            {{code.Name}}
                          </option>
                        </select>
                      </div>

                      <div class="ComponentHeaderMaxCrack">
                        <input class="newCompInput_SelectMaxCrack length-input3Small" id="MaxCrackLengthID"
                               placeholder="MaxCrack" type="text" style="height: 40px; width: 65px !important; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid; "
                               [(ngModel)]="component.MaxCrackLength"
                               ngDefaultControl required>
                      </div>

                      <div class="ComponentHeadercolor">
                        <select class="newCompInput_Select length-input3large" id="UOmId"
                                placeholder="UOM" style="height: 40px;display: inline !important; background-color: #F4F7FA;
                                          color: #1D2F36; min-height: 40px; padding: 10px; min-width: 78px !important; width: 78px !important"
                                [(ngModel)]="component.UOM" ngDefaultControl
                                [attr.disabled]=true
                                required>
                          <option value="1">mm</option>
                          <option value="2">inches</option>

                        </select>
                      </div>

                      <div class="ComponentHeadercolor" style="display: none; ">
                        <select class="newCompInput_Select" id="SeverityTypeID"
                                placeholder="Severity" style="height: 40px;display: inline !important; background-color: #F4F7FA;
                                          color: #1D2F36; min-height: 40px; padding: 10px;"
                                [(ngModel)]="component.severityType" ngDefaultControl
                                required class="length-input3">
                          <option value="0"></option>
                          <option [value]="se.ID"
                                  *ngFor="let se of SeverityList">
                            {{se.Name}}
                          </option>
                        </select>
                      </div>
                      <!-- TT-5655  -->
                      <div style="width:50px">
                        <span title="Move up"
                              class="input-icon image-icon-padding sort-component-icon"
                              style="margin-right: 16px!important"
                              *ngIf="isFirstComponentInList(component.Id, component.CompTypeId)"
                              (click)="recalculateSortOrder(component.Id, false, component.IsNew)">
                          <i class="material-icons">arrow_upward</i>
                        </span>
                      </div>
                      <div style="width:50px">
                        <span title="Move down"
                              class="input-icon image-icon-padding sort-component-icon"
                              style="margin-right: 16px!important"
                              *ngIf="isLastComponentInList(component.Id, component.CompTypeId)"
                              (click)="recalculateSortOrder(component.Id, true, component.IsNew)">
                          <i class="material-icons">arrow_downward</i>
                        </span>
                      </div>
                      <div style="width:50px">
                        <span *ngIf="(component.IsNew)" title="Delete" style="cursor: pointer;"
                              class="input-icon image-icon-padding"
                              (click)="deleteNewComponent(component.Id)">
                          <i class="material-icons">delete</i>
                        </span>
                        <span *ngIf="(!(component.IsNew) && !(component.hasObPoint))" title="Delete" style="cursor: pointer;"
                              class="input-icon image-icon-padding"
                              (click)="deleteOldComponent(component)">
                          <i class="material-icons">delete</i>
                        </span>
                      </div>
                    </div>
                  </mat-list-item>
                </ng-container>
              </mat-selection-list>
              <div style="visibility: hidden; margin-top: 24px; " #scrollTarget>.</div>
            </div>
          </div>


          <div class="input-container"
               style="display: flex;flex-direction: row;">
            <div style="margin-right: 6px; text-wrap: nowrap; margin-top: -17px; display: flex; flex-direction: column;">
              <div>
                <span style="font-weight: bold;">Add New Component</span>
              </div>
              <div style="margin-left: 36px;">
                <select class="newCompMatInput_Select" id="ddlSchematicsNew" (change)="setNewComponentType()"
                        style="width: 245px; height: 40px; background-color: #F4F7FA;
                                          color: #1D2F36; min-height: 40px; padding: 10px;"
                        [(ngModel)]="newComponentSchematicId"
                        required>
                  <option value="0"></option>
                  <option [value]="sch.Id"
                          *ngFor="let sch of visibleSchematics" [ngClass]="{
                          'associated-option' :
                          newComponentTypeId>
                    0 &&
                    isSchematicAssociated(sch),

                    'faded-option':
                    newComponentTypeId > 0 &&
                    !isSchematicAssociated(sch)
                    }">
                    {{ getSchematicDisplay(sch) }}
                  </option>
                </select>
              </div>
            </div>
            <div>
              <select id="type" class="newcomps newCompInput_Select" (change)="setNewComponentSchematic()"
                      style="min-width: 245px;height: 40px;display: inline !important; background-color: #F4F7FA;
                  color: #1D2F36; min-height: 40px; padding: 10px;"
                      placeholder="Select Type" [(ngModel)]="newComponentTypeId" ngDefaultControl
                      required>
                <option value="0"></option>
                <option [value]="type.Id" *ngFor="let type of componentTypeList" [ngClass]="{
                        'associated-option' : newComponentSchematicId>
                  0 &&
                  isComponentTypeAssociated(type.Id),
                  'faded-option':
                  newComponentSchematicId > 0 &&
                  !isComponentTypeAssociated(type.Id)
                  }">

                  {{ getComponentTypeDisplay(type) }}
                </option>
              </select>

              <div style="display: none; margin-left: 15%;">
                <a class="button" (click)="addNewComponentType()">
                  <i class="material-icons button__icon"> add_circle_outline</i><span class="button__text">New Type</span>
                </a>
              </div>

            </div>
            <!---->
            <input type="text" class="newcomps newCompInput_Select"
                   style="margin-right: 5px !important; width: 300px !important; min-width: 300px !important;"
                   (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Component name"
                   [(ngModel)]="newComponentName" />

            <div class="ComponentHeaderGET">
              <span>&nbsp;</span>
            </div>
            <div class="ComponentHeaderGET">
              <span>&nbsp;</span>
            </div>

            <select id="make" class="newcomps select-measurement-point"
                    style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black; width: 150px !important; min-width: 150px !important;"
                    placeholder="Select Make" [(ngModel)]="newComponentMakeId" ngDefaultControl
                    required>
              <option value="0"></option>
              <option [value]="make.Id" *ngFor="let make of makeList">
                {{make.Name}}
              </option>
            </select>

            <input type="text" class="newcomps newCompInput_Select"
                   style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black; width: 150px !important; min-width: 150px !important;"
                   (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Part No."
                   [(ngModel)]="newComponentPartNo" />

            <input type="text" class="newcomps newCompInput_SelectPartNo"
                   style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black; width: 150px !important; min-width: 150px !important;"
                   (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Customer Part No."
                   [(ngModel)]="newComponentCusPartNo" />




            <input type="text" class="newcomps"
                   style="height: 40px; width: 78px !important; min-width: 78px !important; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; "
                   (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Budget Life"
                   [(ngModel)]="newcompBudgetLife" />

            <mat-checkbox id="newComCritical" [(ngModel)]="newComponentCritical"
                          [checked]="newComponentCritical"
                          style="margin-left: 16px!important; margin-right: 30px!important;-webkit-text-emphasis-style: filled;"
                          color="primary" (change)="isCriticalChangedevent($event)">
            </mat-checkbox>
            <mat-checkbox id="newGETCritical" [(ngModel)]="isGETCritical"
                          [checked]="isGETCritical"
                          style="margin-left: 16px!important; margin-right: 30px!important;-webkit-text-emphasis-style: filled;"
                          color="primary" (change)="isGETChangedevent($event)">
            </mat-checkbox>

            <!-- TT-5655  -->
            <select id="make" class="newcomps select-measurement-point"
                    style="height: 40px; width: 100px !important; min-width: 100px !important; display: none !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid; "
                    placeholder="Color" [(ngModel)]="NewcolorCode" ngDefaultControl
                    required>
              <option value="0"></option>
              <option [value]="code.ID" *ngFor="let code of colorCodeList">
                {{code.Name}}
              </option>
            </select>

            <input type="text" class="newcomps newCompInput_SelectMaxCrack"
                   style="height: 40px; width: 65px !important; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid; "
                   placeholder="Max Crack"
                   [(ngModel)]="NewMaxCrackLength" />



            <select id="make" class="newcomps"
                    style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; margin-right: 5px; min-width: 78px !important; width: 78px !important; border: 1px solid black;"
                    placeholder="UOM" [(ngModel)]="NewUOM" ngDefaultControl [attr.disabled]=true
                    required class="select-measurement-point">
              <option [value]="1">mm</option>
              <option [value]="2">inches</option>
            </select>


            <select id="make" class="newcomps"
                    style="height: 40px;display: none !important; background-color: #F4F7FA;
                                          color: #1D2F36; min-height: 40px; padding: 10px; border: 1px solid black;"
                    placeholder="Severity" [(ngModel)]="Newseverity" ngDefaultControl
                    required class="select-measurement-point">
              <option value="0"></option>
              <option [value]="se.ID" *ngFor="let se of SeverityList">
                {{se.Name}}
              </option>
            </select>

            <!-- TT-5655  -->


            <a class="button" style="height:0%" (click)="addNewComponent(scrollTarget)">
              <i class="material-icons button__icon">add</i><span class="button__text">Add</span>
            </a>
          </div>

        </div>
      </div>

    </div>

    <div class="button-container">
      <button mat-raised-button (click)="skipChanges()">Skip Changes & Go To Next</button>
      <button mat-raised-button color="warn" [disabled]="loading" [class.loading]="loading" (click)="SaveComponent()">Save Changes & Go To Next</button>
    </div>
  </div>
</div>
<!--<schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
    [(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
    [(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement" (mouseoverMP)="onMouseOverMP($event)"
    (mouseoverOP)="onMouseOverOP($event)" [schematic]="selectedSchematic"
    (closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)"
    (mousedown)="onMouseButton_Schematic($event)" (mouseup)="onMouseButton_Schematic($event)"
    (mousemove)="onMouseMove_Schematic($event)" [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate"></schemantic-op-popup> -->
<!-- <schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
[(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
[(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement"  (mouseoverMP)="onMouseOverMP($event)"
(mouseoverOP)="onMouseOverOP($event)" (mousedown)="onMouseButton_Schematic($event)" (mouseup)="onMouseButton_Schematic($event)"
(mousemove)="onMouseMove_Schematic($event)"
[schematic]="selectedSchematic"
(closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)"
 [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate"></schemantic-op-popup> -->

<schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
                     [(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
                     [(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement"
                     [schematic]="selectedSchematic"
                     (closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)"
                     [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate"></schemantic-op-popup>
